const degradedServicesErrorDataPush = (degradedServiceMessage: string) => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      error: {
        type: "connection",
        message: degradedServiceMessage,
      },
    });
  }
};

export default degradedServicesErrorDataPush;
